import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { WixFlowContext } from './WixFlowContext';
// todo: import noop from @wix/funnel-utils
const noop = () => {};
export const PreviewProvider = props => {
  const {
    service
  } = props;
  const value = {
    next: noop,
    back: noop,
    service,
    showFallback: noop
  };
  return /*#__PURE__*/React.createElement(WixFlowContext.Provider, _extends({}, props, {
    value: value
  }));
};
//# sourceMappingURL=PreviewProvider.js.map